import { Tooltip } from '@mantine/core'
import { Check, X, Trash2, Pencil } from 'lucide-react'

import DNButton from 'src/components/Buttons/Button/DNButton'

interface JobListingHeaderProps {
  title: string
  isEditMode: boolean
  onToggleEdit: () => void
  onSave?: () => void
  onDelete?: () => void
  isSaving?: boolean
  canSave?: boolean
}

const JobListingHeader = ({
  title,
  isEditMode,
  onToggleEdit,
  onSave,
  onDelete,
  isSaving = false,
  canSave = true,
}: JobListingHeaderProps) => {
  return (
    <div className="flex flex-row items-start justify-between text-sm font-medium">
      <div className="flex w-full flex-col gap-2">
        <div className="flex flex-row items-center justify-between gap-1">
          <div className="flex-1">{title}</div>
          <div className="flex items-center gap-2">
            {!isEditMode && !isSaving && (
              <>
                <DNButton variant="transparent" onClick={onToggleEdit}>
                  <Pencil size={12} />
                  Edit
                </DNButton>
                <DNButton
                  variant="transparent"
                  onClick={onDelete}
                  className="text-doubleNickel-error-500"
                >
                  <Trash2 size={12} />
                  Delete
                </DNButton>
              </>
            )}
            {isEditMode && !isSaving && (
              <>
                <Tooltip
                  label={
                    !canSave
                      ? 'Please fix form errors before saving'
                      : 'Save changes'
                  }
                  position="bottom"
                  disabled={canSave}
                >
                  <DNButton
                    variant="transparent"
                    onClick={onSave}
                    disabled={!canSave}
                    className="text-doubleNickel-success-500"
                  >
                    <Check size={14} />
                    Save
                  </DNButton>
                </Tooltip>
                <DNButton
                  variant="transparent"
                  onClick={onToggleEdit}
                  className="text-doubleNickel-error-500"
                >
                  <X size={14} />
                  Cancel
                </DNButton>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default JobListingHeader
